import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService } from '../auth/login.service';
import { Router } from '@angular/router';
import { ProductsService } from '../Products/products.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private loginService: LoginService, 
    private router: Router,
    private productsService: ProductsService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status === 401) {
          console.log("error", error);
          // Reset all product filters and state before logout
          this.productsService.resetAllState();
          // Logout and clear authentication data
          this.loginService.logout();
          // Navigate to home with clean state
          this.router.navigate(['/'], { 
            queryParams: {},
            replaceUrl: true 
          });
        }
        return throwError(error);
      })
    );
  }
}
